import { LicenseException } from '@/domain/licensing/exception/LicenseException'

export class LicenseNotFoundException extends LicenseException
{
  
}
